import { useState, useEffect, useMemo } from 'react';

import { dataGridPremiumColumns } from '../../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../../Interface';
import documentTypeService from '../../../service/newDocumentType.service';
import { DocumentDirectionField } from '../../../config/DocumentDirection';

const DocumentTypeReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'documentTypeId', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    documentTypeService.getDocumentTypes(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = useMemo(() => {
    return dataGridPremiumColumns([
      {
        field: 'documentTypeId',
        headerName: 'Obj. kód',
        type: 'string',
      },
      {
        field: 'name',
        headerName: 'Bizonylattípus neve',
        type: 'string',
      },
      {
        field: 'direction',
        headerName: 'Irány',
        type: 'string',
        sortable: false,
        renderCell: (data) => {
          const findedDirection = DocumentDirectionField.find((direction) => direction.value === data.row.direction);
          return findedDirection?.label;
        },
      },
      {
        field: 'inventoryAccounting',
        headerName: 'Készletkönyvelés',
        type: 'boolean',
        sortable: false,
      },
      {
        field: 'active',
        headerName: 'Aktív',
        type: 'boolean',
        sortable: false,
      },
      {
        field: 'enableSettlement',
        headerName: 'Elszámolás',
        type: 'boolean',
        sortable: false,
      },
      {
        field: 'defaultItemCode',
        headerName: 'Alapértelmezett cikk',
        type: 'string',
        sortable: false,
        renderCell: (data) => {
          const itemCode = data.row?.defItem?.itemCode;
          const itemName = data.row?.defItem?.itemName;
          return itemCode && itemName ? `${data.row?.defItem?.itemCode} - ${data.row?.defItem?.itemName}` : '';
        },
      },
      {
        field: 'editableItemName',
        headerName: 'Cikkmegnevezés átírható',
        type: 'boolean',
        sortable: false,
      },
      {
        field: 'additionalCost',
        headerName: 'Mellékköltség',
        type: 'boolean',
        sortable: false,
      },
      {
        field: 'invoice',
        headerName: 'Számla',
        type: 'boolean',
        sortable: false,
      },
    ]);
  }, []);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.documentTypes}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      getRowId={(row) => row.documentTypeId}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default DocumentTypeReports;
